import script from "./CustomTableTiptap.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTableTiptap.vue?vue&type=script&setup=true&lang=js"

import "./CustomTableTiptap.vue?vue&type=style&index=0&id=73373432&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73373432"]])

export default __exports__